module.exports = __webpack_public_path__ + "img/mining_icon.75068d3b.png";